import * as types from "./constants";

export default {
    [types.SET_LOADING](state, data) {
        state.loading = data;
    },

    [types.SET_DATA_PREVIEW](state, data) {
        state.docPreview = data;
    },

    [types.TOGGLE_MODAL_PREVIEW_DOC](state, data) {
        state.visiblePreviewModal = data;
    },

    [types.VALIDATE_QUESTION](state, value) {
        state.validate_question = value;
    },

    [types.SET_COMMENT_LIST](state, data) {
        state.listComment = data;
    },

    [types.SET_COMMENT_DETAIL](state, data) {
        state.commentDetail = data;
    },

    [types.SET_PARAM_SEARCH_COMMENTS](state, data) {
        state.paramsSearchComments = data;
    },

    [types.SET_PARAM_SEARCH_COMMENT](state, data) {
        state.paramsSearchCommentDetail = data;
    },

    [types.SET_PAGING_COMMENT](state, data) {
        state.pagingComment = data;
    },

    [types.ACTION_CHECK_CORRECT_QUESTION](state, data) {
        state.actionCheckQuestion = data;
    },

    [types.TOGGLE_DRAW_SHAPE_TOOL](state, data) {
        state.toggle_draw = data;
    },

    [types.DRAW_DATA](state, data) {
        state.draw_shape_data = data;
    },

    [types.TOGGLE_GUIDE_ACTIVE_BOOK](state, data) {
        state.isShowGuideActiveBook = data;
    },

    [types.TOGGLE_MODAL_ACTIVE_PAGE](state, data) {
        state.isShowModalActiveBookPage = data;
    },

    [types.SET_ID_ACTIVE_CODE_BOOK_HEADER](state, data) {
        state.idActiveBookSuccessheader = data;
    },

    [types.SET_DOC_SLIDER_DATA](state, data) {
        state.docSlider = data;
    },

    [types.TOGGLE_MODAL_DOC_SLIDER](state, data) {
        state.visiblePreviewSliderModal = data;
    },

    [types.TOGGLE_MODALACTIVE_BOOK](state, data) {
        state.isShowActiveBook = data;
    },

    [types.SET_BOOK_ACTIVE_WANT](state, data) {
        state.bookActiveWant = data;
    },

    [types.SET_BOOK_ID_ACTIVE_SUCCESS](state, data) {
        state.idBookActiveSuccess = data;
    },

    [types.TOGGLE_MODAL_SHARE](state, data) {
        state.isShowModalShare = data;
    },

    [types.SET_INFO_MEDIA_SHARE](state, data) {
        state.mediaShareInfo = data;
    },
    [types.GET_COUNT_NOTIFI_NOT_RED](state, data) {
        state.getCountNotifiNotRed = data;
    },
    [types.SET_DATA_DETAIL_NOTIFI](state, data) {
        state.getDataDetailNotifi = data;
    },
    [types.SET_PARAM_DISPLAY](state, data) {
        state.getPramDisplay = data;
    },

    [types.TOGGLE_MODAL_SHOW_ERROR](state, data) {
        state.isShowModalError = data;
    },

    [types.TOGGLE_MODAL_SHOW_HELP](state, data) {
        state.isShowModalHelp = data;
    },
    [types.TOGGLE_MODAL_SHOW_NOTIFY](state, data) {
        state.isShowModalNotify = data;
    },

    [types.SET_DATA_MODAL_NOTI](state, data) {
        state.getDataModalNoti = data;
    },

    [types.CHECK_INFO_EXCERCISE](state, data) {
      state.getInfoExcercise = data;
  },

    
    
    

    [types.SET_LIST_HELP](state, data) {
		state.setListHelp = data;
    },

    [types.SET_ID_DETAIL_HELP](state, data) {
		state.setIdDetailHelp = data;
    },

    [types.GET_HELP_DETAIL](state, data) {
		state.getHelpDetail = data;
    },

    [types.GET_HELP_VIDEO](state, data) {
		state.getHelpVideo = data;
    },

    [types.SET_ROUTER_HELP](state, data) {
		state.setRouterHelp = data;
    },

    [types.GET_SHOW_VIDEO_HELP](state, data) {
		state.getShowVideoHelp = data;
    },

    [types.SET_BOOKID_FOR_ERROR](state, data) {
		state.setBookIdForError = data;
    },

    [types.SET_BOOK_INDEX_ID](state, data) {
		state.setBookIndexId = data;
    },

    [types.SET_PAGE_NO_BOOK](state, data) {
		state.setPageNoBook = data;
    },

    [types.SET_BOOK_PAGE_LINK_ID](state, data) {
		state.setBookPageLinkId = data;
    },

    [types.SET_QUESTION_ID](state, data) {
		state.setQuestionId = data;
    },

    [types.SET_INFO_LIBRARY](state, data) {
		state.setInfoLibrary = data;
    },

    [types.ACTION_SET_COUNT_VIEW](state, data) {
		state.setCountView = data;
    },

    [types.CHECK_PAGE_EXCERCISE](state, data) {
		state.setCheckExcercise = data;
    },

    [types.CHECK_SLIDE_ACTIVE_BOOK](state, data) {
		state.setCheckSlideActiveBook = data;
    },

    [types.CHECK_ARRAY_SLIDE](state, data) {
      state.imgSlide = data;
    }
    
};